<template>
  <div class="review">

    <Disclaimer v-if="data.status === 'PUBLISHED'" />

    <!-- <h1 class="review__title">{{ $t('review.CREATE_COPY_OF_MASTER_COURSE') }}</h1> -->
    <h1 class="review__title" v-html="$t('review.CREATE_COPY_OF_MASTER_COURSE')"></h1>
    <h3 class="review__step">{{ $t('review.STEP_NUMBER', { number: 5 }) }}</h3>
    <h5 class="review__step-data">{{ $t('review.CHECK_INFORMATION_IS_CORRECT') }}</h5>
    <div class="review__containers">

      <!-- PASO 1 -->
      <div class="review__container">
        <div class="review__container-title">
          <span>{{ $t('review.GENERAL_CONFIGURATION') }}</span>  
          <router-link to="edit"><i class="material-icons">edit</i> {{ $t('global.EDIT') }}</router-link>
        </div>

        <div class="review__table review__table--general">
          <div class="review__item">
            <span class="review__item-title">{{ $t('review.SHORT_NAME') }}</span>
            <span class="review__item-content">{{ data.internalName }}</span>
          </div>
          <!-- <div class="review__item">
            <span class="review__item-title">Público</span>
            <span class="review__item-content">Docentes</span>
          </div>
          <div class="review__item">
            <span class="review__item-title">Categoría</span>
            <span class="review__item-content">Docentes Chile</span>
          </div> -->
          <div class="review__item">
            <span class="review__item-title">{{ $t('review.FULL_NAME') }}</span>
            <span class="review__item-content">{{ data.name }}</span>
          </div>

          <div class="review__item">
            <span class="review__item-title">{{ $t('review.COURSE_TYPE') }}</span>
            <span class="review__item-content">{{ $t(`course.courseTypes.${data.courseType}`) }}</span>
          </div>

          <!-- targetType -->
          <div class="review__item">
            <span class="review__item-title">{{ $t('review.TARGET_AUDIENCE') }}</span>
            <span class="review__item-content">{{ $t(`course.targetTypes.${data.targetType}`) }}</span>
          </div>
        </div>
      </div>

      <!-- PASO 2 -->

      <div class="review__container">
        <div class="review__container-title">
          <span>{{ $t('review.COURSE_INFORMATION') }}</span>  
          <router-link to="information"><i class="material-icons">edit</i> {{ $t('global.EDIT') }}</router-link>
        </div>

        <div class="review__table">
          <div class="review__item review__item">
            <span class="review__item-title">{{ $t('review.MODALITY') }}</span>
            <span class="review__item-content">{{ creationOptions.modalities.find(modality => modality.id === data.modalityId)?.name }}</span>
          </div>
          <div class="review__item">
            <span class="review__item-title">{{ $t('review.HOUR_DEDICATION') }}</span>
            <span class="review__item-content">{{ data.hourDedication }} {{ $t('review.HOURS_PER_WEEK') }}</span>
          </div>
          <div class="review__item">
            <span class="review__item-title">{{ $t('review.TOTAL_DURATION') }}</span>
            <span class="review__item-content">{{ data.weekDuration }} {{ $t('review.WEEKS') }}</span>
          </div>
          <div class="review__item--full">
            <span class="review__item-title">{{ $t('review.DESCRIPTION') }}</span>
            <span class="review__item-content">{{ data.description }}</span>
          </div>
          <!-- <div class="review__item--full">
            <span class="review__item-title">Requisitos</span>
            <span class="review__item-content">Para realizar este curso no necesitarás conocimientos previos pero sí, curiosidad y apertura para reflexionar y cuestionarte.</span>
          </div> -->
        </div>
      </div>

      <!-- PASO 3 -->

      <div class="review__container">
        <div class="review__container-title">
          <span>{{ $t('review.COURSE_STRUCTURE') }}</span>  
          <router-link to="structure"><i class="material-icons">edit</i> {{ $t('global.EDIT') }}</router-link>
        </div>

        <div class="review__table">
          <span class="review__item-title">{{ $t('review.UNIT') }}</span>
          <span class="review__item-title">{{ $t('review.MODULE') }}</span>
          <span class="review__item-title">{{ $t('review.PUBLICATION') }}</span>

          <template v-for="(unit, unitIdx) in data.units" :key="unitIdx">
            <span :style="{gridRow: `span ${unit.modules.length}`}" class="review__item-content">{{ unit.name }}</span>
            <template v-for="(module, moduleIdx) in unit.modules" :key="moduleIdx">
              <span class="review__item-content">{{ module.name }}</span>
              <span class="review__item-content">
                {{ module.publicationInterval === 0 ? $t('review.COURSE_START') : $t('review.WEEKS_INTERVAL', { weeks: module.publicationInterval }) }}
              </span>
            </template>
            <span v-if="unitIdx !== data.units.length - 1" :style="{ height: '1px', backgroundColor: '#D9D9D9' }" class="review__item--full"></span>
          </template>
        </div>

        <div v-if="data.finalPractice" class="review__table">
          <div class="review__item">
            <span class="review__item-title">{{ $t('review.PRACTICE_WITH_STUDENTS') }}</span>
            <span class="review__item-content">{{ $t('global.YES') }}</span>
          </div>
          <div class="review__item">
            <span class="review__item-title">{{ $t('review.PRACTICE_TYPE') }}</span>
            <!-- Check if data.finalPractice.modules[0].type is 'ContentShare' -->
              <span v-if="data.finalPractice.modules[0].type === 'ContentShare'" class="review__item-content">{{ $t('review.SITUATED_PRACTICE') }}</span>

              <!-- If it's not 'ContentShare', display the actual value -->
              <span v-else class="review__item-content">{{ data.finalPractice.modules[0].type }}</span>
          </div>
        </div>
      </div>

      <!-- PASO 4 -->

      <div class="review__container" v-if="data.courseType != 1">
        <div class="review__container-title">
          <span>{{ $t('review.CERTIFICATION') }}</span>
          <router-link to="certificate"><i class="material-icons">edit</i> {{ $t('global.EDIT') }}</router-link>
        </div>

        <div :style="{ rowGap: '16px' }" class="review__table">
          <span class="review__item--full review__item-title">{{ $t('review.CONDITIONS') }}</span>
          
          <div class="review__item--check">
            <i class="material-icons-outlined">done</i>
            {{ data.percentajeToCertificate }}% {{ $t('review.MANDATORY_ACTIVITIES_SUBMITTED') }}
          </div>
          
          <div class="review__item--check">
            <i class="material-icons-outlined">{{ data.needFinalPractice ? 'done' : 'close' }}</i>
            {{ $t('review.STUDENT_PRACTICE_SUBMITTED') }}
          </div>
          

          <div>

          </div>


          <div>
            <span class="review__item--full review__item-title">{{ $t('review.PROGRAM_NAME') }}</span>
            <span class="review__item-content">{{ data.certificateName || '-' }}</span>
          </div>

          <div>
            <span class="review__item--full review__item-title">{{ $t('review.SUBTITLE') }}</span>
            <span class="review__item-content">{{ data.certificateDescription || '-' }}</span>
          </div>

            <div>
              <span class="review__item--full review__item-title">
              {{ $t('review.TOTAL_DURATION_IN', { hourType: creationOptions.certificateHourTypes.find(hourType => hourType.id === data.certificateHourTypeId)?.name }) }}
            </span>
            <span class="review__item-content">{{ data.durationInHours }} {{ $t('review.HOURS') }}</span>
          </div>

        </div>
        
      </div>

    </div>

    <div class="buttons">
      <button :disabled="submitting" @click="submit(false)" class="button__backward">{{ $t('review.SAVE_DRAFT') }}</button>
      <button :disabled="submitting" @click="submit(true)" class="button__forward">
        {{ data.status === 'PUBLISHED' ? $t('review.MODIFY_COURSE') : $t('review.PUBLISH_COURSE') }}
        <i
          class="material-icons-outlined">arrow_forward</i></button>
    </div>

  </div>
</template>

<script>
import { ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import Disclaimer from './Disclaimer.vue';
import { useI18n } from 'vue-i18n';


export default {
  props: {
    data: {
      type: Object,
      required: true
    },
    creationOptions: {
      type: Array,
      required: true
    }
  },
  components: {
    Disclaimer
  },
  setup() {
    const router = useRouter()
    const route = useRoute()
    const store = useStore()
    const submitting = ref(false)

    const { t } = useI18n();



    const submit = async (publish) => {
      if(submitting.value) return
      try {
        submitting.value = true
        let body = {
          courseCfgId: route.params.courseCfgId,
          status: publish ? 'PUBLISHED' : 'DRAFT'
        }
        await store.dispatch('courses_patchstatus', body)
        router.push('/contents/mastercourses')
      } catch (err) {
        console.log(err)
        store.dispatch('notifications_create', { text: t('review.ERROR_OCCURRED') })
      } finally {
        submitting.value = false
      }
    }
    return {
      router,
      submit,
      submitting
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/main.scss';


.buttons {
  display: flex;
  align-items: center;
  gap: 12px;
  justify-content: center;
  margin-top: 24px;

  .button {
    text-align: center;
    width: fit-content;
    display: flex;
    align-items: center;
    gap: 8px;
    border-radius: 999px;
    padding: 12px 18px;

    &__forward {
      @extend .button;
      color: #fff;
      background-color: $green;
      &:disabled{
        cursor: default;
        opacity: .6;
      }
      .material-icons-outlined{
        font-size: 18px
      }
    }

    &__backward {
      @extend .button;
      color: $green;
      background-color: inherit;
    }
  }
}
.review{
  padding: 28px 0;
  max-width: 985px;
  width: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  &__title{
    font-size: 24px;
    font-weight: 800;
    text-align: center;
    align-self: center;
  }
  &__step{
    font-size: 14px;
    font-weight: 800;
    text-align: center;
    align-self: center;
  }
  &__step-data{
    font-size: 20px;
    font-weight: 600;
    text-align: center;
    align-self: center;
  }
  &__containers{
    display: flex;
    flex-direction: column;
    gap: 36px;
    width: 100%;
    margin-top: 24px;
  }
  &__container{
    display: flex;
    flex-direction: column;
    gap: 12px;
    width: 100%;
    &-title{
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 24px;
      span{
        font-size: 12px;
        font-weight: 700;
      }
      a{
        display: flex;
        align-items: center;
        gap: 8px;
        font-size: 12px;
        font-weight: 600;
        color: $green;
        cursor: pointer;
        .material-icons{
          font-size: 16px;
          color: $green;
        }
      }
    }
  }
  &__table{
    display: grid;
    grid-template-columns: repeat(3, minmax(215px, 1fr));
    border-radius: 10px;
    box-shadow: 5px 5px 35px 0px rgba(217, 217, 217, 0.50);
    padding: 28px 24px;
    row-gap: 28px;

    &--general{
      grid-template-columns: repeat(4, minmax(215px, 1fr));
    }
  }
  &__item{
    display: flex;
    flex-direction: column;
    font-size: 12px;
    gap: 6px;
    &-title{
      font-weight: 600;
      font-size: 12px;
    }
    &-content{
      font-weight: 400;
      font-size: 12px;
    }
    &--full{
      @extend .review__item;
      grid-column-start: 1;
      grid-column-end: 4;
    }
    &--inline-list {
      // @extend .review__item;
      display: flex;
    }
    &--check{
      display: flex;
      align-items: flex-start;
      gap: 12px;
      font-weight: 400;
      font-size: 12px;
      .material-icons-outlined{
        font-size: 16px;
      }
    }
  }
}
</style>